const NAME = "MY_ASSISTANCE_PAGE";

export default NAME;
